import { SelectProps } from '@radix-ui/react-select';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/Select';

import { useGetCustomersInfo } from '@/hooks/useGetCustomersInfo';

interface CustomerSelectProps extends SelectProps {
  additionalOptions?: {
    value: string;
    label: string;
  }[];
}

export function CustomerSelect({
  additionalOptions,
  ...props
}: CustomerSelectProps) {
  const { customersInfo } = useGetCustomersInfo();

  const sortedCustomers = [...customersInfo].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
  );

  return (
    <Select {...props}>
      <SelectTrigger>
        <SelectValue placeholder="Select customer" />
      </SelectTrigger>

      <SelectContent>
        {additionalOptions &&
          additionalOptions.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        {sortedCustomers.map((customer) => (
          <SelectItem key={customer.id} value={customer.id.toString()}>
            {customer.name} ({customer.id})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
